import { create } from 'zustand'

export type Theme = 'light' | 'dark'

const STORAGE_KEY = 'whca-theme'

function getInitialTheme(): Theme {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === 'light' || saved === 'dark') return saved
  } catch {
    // localStorage unavailable — fall back to light.
  }
  return 'light'
}

function applyTheme(theme: Theme) {
  const root = document.documentElement
  if (theme === 'dark') {
    root.classList.add('dark')
  } else {
    root.classList.remove('dark')
  }
}

interface ThemeState {
  theme: Theme
  setTheme: (theme: Theme) => void
  toggle: () => void
}

// Theme is applied to <html> as the `dark` class (Tailwind class strategy) and
// persisted to localStorage. applyTheme() runs on store creation so the initial
// paint matches the saved choice.
export const useThemeStore = create<ThemeState>((set, get) => {
  const initial = getInitialTheme()
  applyTheme(initial)
  return {
    theme: initial,
    setTheme: (theme) => {
      applyTheme(theme)
      try {
        localStorage.setItem(STORAGE_KEY, theme)
      } catch {
        // ignore persistence failure
      }
      set({ theme })
    },
    toggle: () => {
      get().setTheme(get().theme === 'dark' ? 'light' : 'dark')
    },
  }
})
